<template>
  <div class="px-4" style="height: 65vh; overflow-y: scroll">
    <div class="align-items-center">
      <ValidationObserver v-slot="{ invalid }" ref="form">
        <ValidationProvider v-for="(item, i) in form" :key="i" :name="item.title" :rules="i == 1
            ? sendType == 'New Mail' || sendType == 'forward'
              ? ''
              : item.tags.length > 0
                ? ''
                : 'required|email'
            : i == 2 || i == 3 || i == 4
              ? ''
              : 'required'
          " v-slot="{ errors }">
          <b-input-group class="col-12 pr-0" :class="item.hidden ? 'my-1' : ''">
            <template v-if="item.input.match('tag') && item.hidden" #prepend>
              <b-input-group-text style="width: 120px">{{
                item.title
              }}</b-input-group-text>
            </template>
            <template v-else-if="item.input.match('input') && item.title" #prepend>
              <b-input-group-text style="width: 120px">{{
                  item.title
                }}</b-input-group-text>
            </template>
            <transition name="fade">
              <b-form-input v-if="item.hidden &&
                  item.input.match('input') &&
                  item.title != 'Tracking ID'
                  " :disabled="item.disable" v-model="item.value"></b-form-input>
              <b-form-input ref="input_copy" id="input_copy" v-if="item.hidden &&
                  item.input.match('input') &&
                  item.title == 'Tracking ID'
                  " :disabled="item.disable" v-model="item.value"></b-form-input>
              <vue-tags-input v-if="item.input.match('tag') && item.hidden" 
                :ref="'tagInput' + i" style="flex: 1 1 auto"
                :style="item.disable ? 'background:#eaecef' : null" v-model="item.value" 
                :disabled="item.disable"
                placeholder="Select E-mail"
                :tags="item.tags" 
                @before-adding-tag="checkEmail($event)"
                :separators="separators" 
                @tags-changed="(newTags) => (item.tags = newTags)" 
                />
            </transition>
            <b-input-group-append v-if="item.copy">
              <b-button @click="copyTrackingID()" v-if="item.hidden" text="Button" class="px-3 ml-2 bg-blue text-primary"
                variant="traparent"><i class="fa fa-clipboard"></i></b-button>
            </b-input-group-append>
          </b-input-group>
          <small class="text-danger" v-if="sendType != '' && sendType != 'revert'">{{ errors[0] }}</small>
        </ValidationProvider>
        <ValidationProvider rules="" name="Message" v-slot="{ errors }">
          <quill-editor class="ml-3 my-1" :disabled="editorDisable" style="overflow-y: scroll"
            :class="editorDisable ? 'headerDisable' : ''" :style="editorDisable
                ? 'background-color:#e9ecef;font-family: Tahoma; font-size: 10px;'
                : 'font-family: Tahoma; font-size: 10px;'
              " v-model="mail" :options="editorOption"></quill-editor>

          <!-- <small
            class="text-danger"
            v-if="sendType != '' && sendType != 'revert'"
            >{{ errors[0] }}</small
          > -->
        </ValidationProvider>
        <div class="row justify-content-between">
          <div class="col-auto d-flex justify-content-left">
            <div class="d-flex justify-content-end align-items-center text-primary" v-if="isInbound">
              <template v-for="(icon, i) in icons">
                <div @click="changeButton(icon.func)" :key="i" class="icon btn-gray" v-if="!icon.hidden">
                  <Icon v-if="!icon.hidden" :icon="icon.icon" :width="icon.size" :height="icon.size" :class="icon.class"
                    class="mx-1 icon" style="cursor: pointer" />
                  <span v-if="!icon.hidden && icon.name == 'Attach File'">{{ icon.name }}({{ attachments.length }})</span>
                  <span v-else-if="!icon.hidden">{{ icon.name }}</span>
                </div>
              </template>
            </div>
            <div class="d-flex justify-content-end align-items-center text-primary btn-gray" v-if="!isInbound">
              <div @click="newMail()" class="icon">
                <Icon icon="fluent:mail-add-16-regular" width="40" height="40" class="mx-1" style="cursor: pointer" />
                <span>New mail</span>
              </div>
            </div>
          </div>
          <div class="col-auto d-flex align-items-center">
            <b-button v-show="sendType == 'reply' ||
              sendType == 'replyAll' ||
              sendType == 'forward' ||
              sendType == 'New Mail'
              " pill size="lg" :variant="validForm(invalid) ? 'light' : 'primary'" class="mt-2 w-100"
              :disabled="validForm(invalid)" @click="confirmAlert('Confirm to send E-mail ?', 'send')">Send<i
                class="fa fa-send-o ml-2"></i></b-button>
          </div>
        </div>
        <div class="col-12 pr-0">
          <b-modal ref="modal-attachments-file" id="modal-attachments-file" size="xl" centered title="Attachments"
            hide-footer class="theme-modal">
            <div class="file-content">
              <div class="card">
                <div class="">
                  <div class="media">
                    <div class="media-body text-right">
                      <div class="btn btn-outline-primary ml-2" @click="openUpload">
                        <feather type="upload" class="text-top"></feather>
                        Upload
                      </div>
                      <input @change="addFile" ref="fileUpload" type="file" hidden />
                    </div>
                  </div>
                </div>
                <div class="card-body file-manager">
                  <template v-if="attachments.length > 0">
                    <h6>Files</h6>
                    <ul class="files">
                      <li class="file-box" v-for="(n, index) in attachments" :key="n.mail_id+'_attach_'+index">
                        <div class="file-top">
                          <i class="fa fa-file-archive-o txt-secondary"></i>
                          <i class="fa fa-times f-14 text-danger ellips" @click="removeAttachment(index)"></i>
                        </div>
                        <div class="file-bottom">
                          <h6>{{ n.name }}</h6>
                          <p class="mb-1">{{ formatBytes(n.size) }}</p>
                          <p>
                            <a href="javascript:void(0)" @click="downloadFile(
                              n.name,
                              n.contentType,
                              n.contentBytes,
                              n.size,
                              n.from,
                              n.mail_id
                            )
                              ">Download</a>
                          </p>
                        </div>
                      </li>
                    </ul>
                  </template>
                </div>
              </div>
            </div>
          </b-modal>
        </div>
      </ValidationObserver>
    </div>
    <section>
      <div class="p-0" v-for="(n, index) in historyBodyList" :key="n.mail_id+'_hist_'+index">
        <b-card style="margin-left: 50px; background-color: #cec9ffa6" header-tag="div" header-bg-variant="primary"
          class="card-absolute" v-if="n.type == 'Inbound'">
          <!-- <h5 slot="header">Email</h5> -->
          <b-card-text class="mb-0" style="height: 100%" v-html="n.body">
          </b-card-text>
        </b-card>
        <b-card style="margin-right: 50px; background-color: #fef0f4" header-tag="div" header-bg-variant="danger"
          class="card-absolute" v-else-if="n.type == 'Outbound'">
          <!-- <h5 slot="header">Email</h5> -->
          <b-card-text class="mb-0" style="height: 100%" v-html="n.body">
          </b-card-text>
        </b-card>
      </div>
      <!-- <div class="p-0" v-for="(n, index) in historyBodyList" :key="index">
        <div class="ribbon-wrapper m-0">
          <div
            class="card-body pl-2 p-0"
            :ref="'element' + index"
            :id="'element' + index"
          >
            <div
              class="ribbon-custom-left ribbon-primary"
              v-if="n.type == 'Outbound'"
            >
              Email
            </div>
            <div
              class="ribbon-custom-right ribbon-danger"
              v-else-if="n.type == 'Inbound'"
            >
              Email
            </div>
            <p
              class="mt-3 border rounded p-3"
              style="height: 100%"
              v-html="n.body"
            ></p>
          </div>
        </div>
      </div> -->
    </section>
  </div>
</template>
<script>
import { PublicClientApplication } from '@azure/msal-browser';
import { msal_config } from '../../constants/service';
import { requestService } from './../../_services';
// import { VueEditor } from 'vue2-editor';
import { Icon } from '@iconify/vue2';
import Quill from 'quill';
import ImageResize from 'quill-image-resize-vue';
Quill.register('modules/imageResize', ImageResize);
export default {
  components: {
    Icon,
  },
  props: {
    scrollId: String,
    data: Object,
  },
  data() {
    return {
      texto: 'h',
      editorOption: {
        modules: {
          //imageDrop: true,
          // imagePaste: true,
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ direction: 'rtl' }],
            // [{ size: ['small', false, 'large', 'huge'] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            // [{ font: [] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ['clean'],
            ['link', 'image', 'video'],
            ['template-partediario'],
          ],
          imageResize: {
            displayStyles: {
              backgroundColor: 'black',
              border: 'none',
              color: 'white',
            },

            modules: ['DisplaySize', 'Resize'],
          },
        },
      },
      editorDisable: true,
      separators: [';', ',', ' ','<','>'],
      isInbound: false,
      sendType: '',
      mail: '',
      mailId: '',
      historyBodyList: [],
      attachments: [],
      temp_attachments: [],
      attachFile: [],
      mailItone: process.env.NODE_ENV === 'production' ? 'itone-cs@itone.co.th' : 'ticket@cloudsoft.co.th',
      tempMailDetail: {},
      form: [
        {
          title: 'From',
          input: 'input',
          value: '',
          tags: [],
          disable: true,
          hidden: true,
        },
        {
          title: 'To',
          input: 'tag',
          value: '',
          tags: [],
          disable: true,
          hidden: true,
        },
        {
          title: 'CC',
          input: 'tag',
          value: '',
          tags: [],
          disable: true,
          hidden: true,
        },
        {
          title: 'BCC',
          input: 'tag',
          value: '',
          tags: [],
          disable: true,
          hidden: true,
        },
        {
          title: 'Subject',
          input: 'input',
          value: '',
          tags: [],
          disable: true,
          hidden: true,
        },
        {
          title: 'Tracking ID',
          input: 'input',
          value: '',
          tags: [],
          disable: true,
          hidden: true,
          copy: true,
        },
      ],
      icons: [
        {
          icon: 'icon-park-outline:accept-email',
          size: 36,
          class: 'mt-1',
          hidden: true,
          name: 'Reply',
          func: 'reply',
        },
        {
          icon: 'fluent:mail-arrow-double-back-16-regular',
          size: 40,
          class: '',
          hidden: true,
          name: 'Reply All',
          func: 'replyAll',
        },
        {
          icon: 'icon-park-outline:send-email',
          size: 36,
          class: 'mt-1',
          hidden: true,
          name: 'Forward',
          func: 'forward',
        },
        {
          icon: 'fluent:mail-attach-16-regular',
          size: 40,
          class: '',
          hidden: true,
          name: 'Attach File',
          func: 'file',
        },
        {
          icon: 'fluent:mail-dismiss-16-regular',
          size: 40,
          class: '',
          hidden: true,
          name: 'Close',
          func: 'close',
        },
        {
          icon: 'fluent:mail-clock-16-regular',
          size: 40,
          class: '',
          hidden: true,
          name: 'Hold',
          func: 'hold',
        },
        {
          icon: 'mdi:email-sync-outline',
          size: 36,
          class: 'mt-1',
          hidden: true,
          func: 'revert',
          name: 'Reverse',
        },
      ],
      user: {},
      subjectArray: [],
      template: {},
      pageCount: 0,
      mailAttID: '',
      inboundMail: "itone-cs@accenture.com",
      $msalInstance: {},
      state:null, //use for keep state (forward , reply) for handle to clear attachment file or not
    };
  },
  created() {
    window.addEventListener('beforeunload', this.setTimeMachineMail);
  },
  computed: {},
  watch: {
    scrollId(newValue, oldValue) {
      document.getElementById(newValue).scrollIntoView({
        behavior: 'smooth',
      });
      this.$emit('resetId');
    },
    data(newValue, oldValue) {
      if (newValue) {
        if (this.isInbound) {
          this.form[4].value = newValue.subject;
          this.mail = newValue.body;
        }
      } else {
        this.form[4].value = '';
        this.mail = '';
      }
    },
  },
  mounted() {
    this.$msalInstance = new PublicClientApplication(msal_config);
    const self = this;
    this.user = JSON.parse(localStorage.getItem('userinfo'));
    this.$root.$on('notificationToAgent', (data) => {
      self.setMailNotification(data);
    });
    this.$root.$on('notificationToCloseJob', (data) => {
      self.notificationCloseJob(data);
    });
    this.$root.$on('setTemplate', (data) => {
      if (self.state == 'forward'){
        self.attachments =  self.attachments_temp;
      } else {
        self.attachments = [];
      }
      if (self.sendType != '') {
        self.template = data;
        if (self.form[4].value != '' && self.form[4].value != null) {
          self.confirmAlert('Confirm use template subject ?', 'template');
        } else {
          if (data.subject != ""){
            self.form[4].value = data.subject;
          }
        }
        self.mail = data.body;
        if (data.file != null) {
          data.file.forEach((element) => {
            element.from = 'internal';
            self.attachments.push(element);
          });
        }
      }
    });
  },
  beforeDestroy() {
    this.setTimeMachineMail();
    this.$root.$off('notificationToCloseJob', null);
    this.$root.$off('notificationToAgent', this.setMailNotification());
    this.$root.$off('setTemplate', null);
  },
  methods: {
    notificationCloseJob(data) {
      if (data == undefined) {
        return;
      }
      if (this.mailId == data.mail_id) {
        this.$swal
          .fire({
            title: 'งานที่คุณทำอยู่ถูกปิดแล้ว กรุณา refresh page',
            icon: 'danger',
            showCancelButton: true,
            confirmButtonColor: '#2971FF',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
          .then((result) => {
            if (result.isConfirmed) {
              location.reload(true);
            }
          });
      }
    },
    copyTrackingID() {
      var copyText = document.getElementById('input_copy');
      copyText.select();
      navigator.clipboard.writeText(copyText.value);
    },
    setTimeMachineMail() {
      if (this.mailId != '') {
        let to = [];
        if (this.form[1].tags.length > 0) {
          this.form[1].tags.forEach((element) => {
            to.push(element.text);
          });
        }
        let cc = [];
        if (this.form[2].tags.length > 0) {
          this.form[2].tags.forEach((element) => {
            cc.push(element.text);
          });
        }
        let bcc = [];
        if (this.form[3].tags.length > 0) {
          this.form[3].tags.forEach((element) => {
            bcc.push(element.text);
          });
        }
        let temp = {
          to: to,
          cc: cc,
          bcc: bcc,
          subject: this.form[4].value,
          message: this.mail,
        };
        localStorage.setItem(this.mailId, JSON.stringify(temp));
      }
    },
    saveByteArray(reportName, byte, type) {
      var blob = new Blob([byte], { type: type });
      var file = new File([blob], reportName);
      return file;
    },
    validForm(invalid) {
      if (invalid) {
        if (
          this.form[1].tags.length > 0 &&
          this.form[4].value != '' &&
          this.mail != ''
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    removeAttachment(i) {
      let arr = this.attachments;
      arr.splice(i, 1);
      this.attachments = arr;
    },
    removeNewAttachment(i) {
      this.attachments.splice(i, 1);
    },
    openUpload() {
      this.$refs.fileUpload.click();
    },
    addFile(event) {
      if (event.target.files[0].size == 0) {
        this.$swal.fire({
          icon: 'error',
          title: 'Try Again',
          text: 'ไม่สามารถเลือกไฟล์ว่างเปล่าได้',
        });
        return;
      }
      if (event.target.files[0].size > 12000000) {
        this.$swal.fire({
          icon: 'error',
          title: 'Try Again',
          text: 'ไม่สามารถเลือกไฟล์ที่มีขนาด มากกว่า 12 MB ได้',
        });
        return;
      }
      const file = {
        file: event.target.files[0],
        size: event.target.files[0].size,
        type: event.target.files[0].type,
        name: event.target.files[0].name,
        contentType: event.target.files[0].type,
        contentBytes: event.target.files[0],
        from: 'external',
      };
      this.attachments.push(file);
    },
    confirmAlert(title, type) {
      this.$swal
        .fire({
          title: title,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#2971FF',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
          camcelButtonText: 'Cancel',
        })
        .then((result) => {
          if (result.isConfirmed) {
            switch (type) {
              case 'send':
                this.onSendEmail();
                break;
              case 'close':
                this.sendType = 'close';
                this.onCloseJob();
                break;
              case 'revert':
                this.sendType = 'revert';
                this.setUpForm('In Process', this.tempMailDetail);
                this.icons[6].hidden = true;
                this.form[1].disable = true;
                this.form[2].disable = true;
                this.form[3].disable = true;
                this.form[4].disable = true;
                this.editorDisable = true;
                break;
              case 'template':
                this.form[4].value = this.template.subject;
                break;
              case 'file':
                this.$refs.dropdown.hide();
                break;
              case 'hold':
                this.sendType = 'hold';
                this.onHoldJob();
                break;
            }
          }
        });
    },
    scroll(id) {
      document.getElementById(id).scrollIntoView({
        behavior: 'smooth',
      });
    },
    clkSend() {
      this.$root.$emit('setContentHistory', this.subjectArray);
    },
    setMailNotification(data) {
      if (data == undefined) {
        return;
      }
      let url = `/api/mail/${data.mail_id}/job/detail`;
      this.mailId = data.mail_id;
      requestService
        .GetFetch('ccp', url)
        .then((response) => {
          if (response.status == 200) {
            self.attachments = [];
            self.temp_attachments = [];
            self.historyBodyList = [];
            self.mailAttID = '';
            response.text().then((text) => {
              let self = this;
              const data = text && JSON.parse(text);
              if (data.data != null) {
                let dataDetail = data.data.detail;
                self.mailAttID = data.data.mail_id;
                let historyList = [];
                if (
                  data.data.body != '' &&
                  data.data.body != null &&
                  data.data.body != undefined &&
                  data.data.detail.type != 'New Mail'
                ) {
                  data.data.body = data.data.body.replaceAll(
                    'background-color:rgb(255,255,255)',
                    ''
                  );
                  const bodyList = data.data.body.split(
                    `<hr tabindex=\"-1\" style=\"display:inline-block; width:98%\">`
                  );

                  if (bodyList.length > 1) {
                    bodyList.forEach((element, index) => {
                      let obj = {
                        body: element,
                        from: data.data.detail.from,
                        type: 'Inbound',
                      };
                      if (
                        element.includes('<b>From:</b>') ||
                        element.includes('<b>ชื่อเรื่อง:</b>')
                      ) {
                        if (element.includes('<b>From:</b>')) {
                          var mySubString = element.substring(
                            element.includes('<b>From:</b>') + 11,
                            element.lastIndexOf('<br><b>Sent:</b>')
                          );
                          var mySubString2 = mySubString.substring(
                            mySubString.indexOf('&lt;') + 4,
                            mySubString.lastIndexOf('&gt;')
                          );
                          let obj2 = {
                            from: mySubString2,
                          };
                          obj.from = mySubString2;
                          if (
                            mySubString2 == self.mailItone ||
                            mySubString2 == 'ticket@cloudsoft.co.th'
                          ) {
                            obj.type = 'Outbound';
                          } else {
                            obj.type = 'Inbound';
                          }
                          historyList.push(obj2);
                        } else if (element.includes('<b>ชื่อเรื่อง:</b>')) {
                          var mySubString = element.substring(
                            element.includes('<b>ชื่อเรื่อง:</b>') + 13,
                            element.lastIndexOf('<br><b>ส่ง:</b>')
                          );
                          var mySubString2 = mySubString.substring(
                            mySubString.indexOf('&lt;') + 4,
                            mySubString.lastIndexOf('&gt;')
                          );
                          let obj2 = {
                            from: mySubString2,
                          };
                          obj.from = mySubString2;
                          if (
                            mySubString2 == self.mailItone ||
                            mySubString2 == 'ticket@cloudsoft.co.th'
                          ) {
                            obj.type = 'Outbound';
                          } else {
                            obj.type = 'Inbound';
                          }
                          historyList.push(obj2);
                        }
                        // let obj={}
                        // var mySubString = element.substring(
                        //   (element.includes('<b>From:</b>') || element.includes('<b>ชื่อเรื่อง:</b>')) + 11,
                        //   (element.lastIndexOf('<br><b>Sent:</b>')|| element.lastIndexOf('<br><b>ส่ง:</b>'))
                        // );
                        // var mySubString2 = mySubString.substring(
                        //   mySubString.indexOf('&lt;') + 4,
                        //   mySubString.lastIndexOf('&gt;')
                        // );
                        // let obj2 = {
                        //   from: mySubString2,
                        // };
                        // obj.from = mySubString2;
                        // if (
                        //   mySubString2 == self.mailItone ||
                        //   mySubString2 == 'ticket@cloudsoft.co.th'
                        // ) {
                        //   obj.type = 'Outbound';
                        // } else {
                        //   obj.type = 'Inbound';
                        // }
                        // historyList.push(obj2);
                      }
                      self.historyBodyList.push(obj);
                    });
                  } else {
                    let obj = {
                      body: data.data.body,
                      from: data.data.detail.from,
                      type: 'Inbound',
                    };
                    let obj2 = {
                      from: data.data.detail.from,
                    };
                    historyList.push(obj2);
                    self.historyBodyList.push(obj);
                  }
                  self.$root.$emit('setContentHistory', historyList);
                }
                if (data.data.attachments != null) {
                  data.data.attachments.forEach((element) => {
                    //console.log("element",element)
                    const file = {
                      // file: self.saveByteArray(
                      //   element['name'],
                      //   element['contentBytes'],
                      //   element['@odata.mediaContentType']
                      // ),
                      contentType: element['contentType'],
                      contentBytes: element['contentBytes'],
                      // contentBytes: '',
                      size: element['size'],
                      type: element['@odata.mediaContentType'],
                      name: element['name'],
                      from: 'inbound',
                      mail_id: data.data.detail.id,
                    };
                    self.temp_attachments.push(file);
                  });
                }
                self.setUpForm(dataDetail.status, dataDetail);
              }
            });
          }
        })
        .catch((err) => {
          this.$swal.fire({
            icon: 'error',
            title: 'Try Again',
            text: err,
          });
        });
    },

    formatBytes(bytes, decimals = 2) {
      if (!+bytes) return '0 Bytes';
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]
        }`;
    },
    downloadFile(filename, type, base64, size, from, mail_id) {
      if ((from == 'external') || (from == 'inbound')) {
        
        //avoid no ext or wrong ext (force to use .eml instead)
        var extension = filename.split('.').pop();
        if ((extension.length > 5) || (extension.length ==0)) {
            type = "message/rfc822"
            filename =  filename + ".eml"
        }

        /*const downloadLink = document.createElement('a');
        var file = base64;
        var filename = filename;
        var blob = new Blob([file]);
        console.log("blob",blob)
        var url = URL.createObjectURL(blob);
        console.log("url",url)
        downloadLink.href = url;
        downloadLink.download = filename;
        downloadLink.click();*/

        const linkSource = `data:${type};base64,${base64}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = filename;
        downloadLink.click();
      } else {
        let object = {
          id: mail_id,
          from: from,
          contentType: type,
          size: size,
          name: filename,
        };      
        //console.log("object",object);
        let url = `/api/mail/download/file`;
        requestService
          .PostCcpFetch('ccp', url, object)
          .then((response) => response.blob())
          .then((blob) => {
            //console.log("blob",blob);
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            link.click();
          })
          .catch((err) => {
            this.$swal.fire({
              text: `${err}`,
              icon: 'error',
              showCancelButton: false,
              confirmButtonColor: '#2971FF',
              confirmButtonText: 'ยืนยัน',
            }).then((result) => {
              if (result.isConfirmed) {
                this.refreshToken()
              }
            });
            // this.$swal.fire({ icon: 'error', title: 'Try Again', text: err });
          });
      }
    },
    onCloseJob() {
      let url = `/api/desktop/close/${this.mailId}/job`;
      const object = {};
      requestService.PostCcpFetch('ccp', url, object).then((response) => {
        this.$swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'Close Success',
        });
        this.$root.$emit('reloadPendingJob');
        this.$root.$emit('setSelectMail', '');
        this.$root.$data.WorkerIO.port.postMessage(['changeStatus', 'acw']);
        this.isInbound = false;
        this.form[3].hidden = false;
        this.form.map((item) => {
          item.value = '';
          item.tags = [];
          item.disable = true;
          item.hidden = true;
        });
        this.attachments = [];
        this.temp_attachments = [];
        this.historyBodyList = [];
        this.editorDisable = true;
        this.mail = '';
        localStorage.removeItem(this.mailId);
        this.mailId = '';
        this.$refs.form.reset();
      }).catch((err) => {
        this.$swal.fire({
          text: `${err}`,
          icon: 'error',
          showCancelButton: false,
          confirmButtonColor: '#2971FF',
          confirmButtonText: 'ยืนยัน',
        }).then((result) => {
          if (result.isConfirmed) {
            this.refreshToken()
          }
        });
        //this.$swal.fire({ icon: 'error', title: 'Try Again', text: err });
      });
    },
    onHoldJob() {
      let object = {
        subject: this.form[4].value,
        body: this.mail,
        to: [],
        cc: [],
        bcc: [],
      };
      let to = [];
      if (this.form[1].tags.length > 0) {
        this.form[1].tags.forEach((element) => {
          to.push(element.text);
        });
        object['to'] = to;
      }
      let cc = [];
      if (this.form[2].tags.length > 0) {
        this.form[2].tags.forEach((element) => {
          cc.push(element.text);
        });
        object['cc'] = cc;
      }
      let bcc = [];
      if (this.form[3].tags.length > 0) {
        this.form[3].tags.forEach((element) => {
          bcc.push(element.text);
        });
        object['bcc'] = bcc;
      }
      let url = `/api/desktop/pending/${this.mailId}/job`;
      requestService.PostCcpFetch('ccp', url, object).then((response) => {
        this.$swal.fire({
          icon: 'info',
          title: 'Success',
          text: 'Hold Success',
        });
        this.$root.$emit('reloadPendingJob');
        this.$root.$emit('setSelectMail', '');
        this.$root.$data.WorkerIO.port.postMessage(['changeStatus', 'acw']);
        this.isInbound = false;
        this.form[3].hidden = false;
        this.form.map((item) => {
          item.value = '';
          item.tags = [];
          item.disable = true;
        });
        this.attachments = [];
        this.temp_attachments = [];
        this.historyBodyList = [];
        this.editorDisable = true;
        this.mail = '';
        this.$refs.form.reset();
        this.pageCount = 0;
        // this.$root.$off('setTemplate', null)
      }).catch((err) => {
        this.$swal.fire({
          text: `${err}`,
          icon: 'error',
          showCancelButton: false,
          confirmButtonColor: '#2971FF',
          confirmButtonText: 'ยืนยัน',
        }).then((result) => {
          if (result.isConfirmed) {
            this.refreshToken()
          }
        });
        // this.$swal.fire({ icon: 'error', title: 'Try Again', text: err });
      });
    },
    refreshToken() {
      /*const loginRequest = {
        scopes: ['User.Read'],
      };
      this.$msalInstance.acquireTokenSilent(silentRequest).then(function (accessTokenResponse){
        const timestampInSeconds = Math.floor(accessTokenResponse.expiresOn.getTime() / 1000);
        var userInfo = localStorage.getItem('userinfo');
        userInfo.access_token_ms=accessTokenResponse.accessToken;
        userInfo.exp_ms=timestampInSeconds
        localStorage.setItem("tokenExpiry", timestampInSeconds);
        localStorage.setItem("userinfo", JSON.stringify(userInfo));
      }).catch(async (error) => {
          console.error(`error during authentication: ${error}`);
          return;
      });*/ 
    },
    changeButton(params) {
      if (params.match('file')) {
        this.$refs['modal-attachments-file'].show();
        return;
      }
      if (params != 'close' && params != 'revert' && params != 'hold') {
        this.sendType = params;
        this.form[1].disable = false;
        this.form[2].disable = false;
        this.form[3].disable = false;
        this.form[4].disable = false;
        this.editorDisable = false;
      }
      if (params.match('close')) {
        this.state = null;
        if (this.mailId != '') {
          this.confirmAlert('Confirm to close job ?', 'close');
        }
      } else if (params == 'reply' || params == 'forward') {
        

        //add Fw,Re to subject
        if  (params == 'forward'){
          this.state = "forward";
          this.attachments_temp = this.attachments;
          this.form[4].value = this.form[4].value.replace("Re: ","");
          if (this.form[4].value.substring(0,3) != "Fw:" ){
            this.form[4].value = "Fw: "+this.form[4].value;
          }
        } else if (params == 'reply'){
          this.state = "reply";
          //clear attach file (no need to send original file when reply)
          this.attachments_temp = this.attachments;
          this.attachments = [];

          this.form[4].value.replace("Fw: ","");
          if (this.form[4].value.substring(0,3) != "Re:" ){
            this.form[4].value = "Re: "+this.form[4].value;
          } 
        }

        if (!this.form[4].value.includes(this.form[5].value)) {
          this.form[4].value = this.form[4].value;
        }
        let checkMe = false;
        this.form[3].tags.forEach((element) => {
          if (element.text == this.user.email) {
            checkMe = true;
          }
        });
        if (!checkMe) {
          this.form[3].tags.push({
            text: this.user.email,
            tiClasses: ['ti-valid'],
          });
          this.form[3].hidden = true;
        }
        if (params == 'forward') {
          this.form[1].tags = [];
        }
        this.form[2].tags = [];
        this.icons[0].hidden = true;
        this.icons[1].hidden = true;
        this.icons[2].hidden = true;
        this.icons[4].hidden = false;
        this.icons[6].hidden = false;
      } else if (params == 'replyAll') {
        //clear attach file (no need to send original file wgen reply or forward)
        this.attachments_temp = this.attachments;
        this.attachments = [];
        
        //add Fw,Re to subject
        if (params == 'replyAll'){
          if (this.form[4].value.substring(0,3) != "Re:" ){
            this.form[4].value = "Re: "+this.form[4].value;
          } 
        }

        this.tempMailDetail.to_recipients.forEach(element => {
          if (element != this.inboundMail) {
            var exists = this.form[1].tags.some(item => item.text === element);
            if (!exists) {
              this.form[1].tags.push({
                text: element,
                tiClasses: ['ti-valid'],
              })
            }
          }
        });
        if (!this.form[4].value.includes(this.form[5].value)) {
          this.form[4].value = this.form[4].value;
        }
        let checkMe = false;
        this.form[3].tags.forEach((element) => {
          if (element.text == this.user.email) {
            checkMe = true;
          }
        });
        if (!checkMe) {
          this.form[3].tags.push({
            text: this.user.email,
            tiClasses: ['ti-valid'],
          });
          this.form[3].hidden = true;
        }
        this.icons[0].hidden = true;
        this.icons[1].hidden = true;
        this.icons[2].hidden = true;
        this.icons[4].hidden = false;
        this.icons[6].hidden = false;
      } else if (params.match('revert')) {
        this.state = null;
        //clear attachment to original
        this.attachments = this.attachments_temp;
        this.attachments_temp = [];

        //remove Fw , Re
        switch(this.form[4].value.substring(0,3)) {
        case "Fw:":
          this.form[4].value = this.form[4].value.replace("Fw: ","");
          break;
        case "Re:":
          this.form[4].value = "Re: "+this.form[4].value;
          this.form[4].value = this.form[4].value.replace("Re: ","");
          break;
        default:
      }

        this.confirmAlert('Confirm to reverse E-mail ?', 'revert');
      } else if (params.match('hold')) {
        this.state = null;
        if (this.mailId != '') {
          this.confirmAlert('Confirm to hold E-mail ?', 'hold');
        }
      }
      // else {
      //   this.icons[0].hidden = true;
      //   this.icons[1].hidden = true;
      //   this.icons[2].hidden = true;
      //   this.icons[4].hidden = false;
      //   this.icons[6].hidden = false;
      // }
    },
    onSendEmail() {
      //console.log("test",0)
      //console.log(this.mail)
      this.mail = this.mail.replaceAll(' ', '&nbsp;');
      this.mail = this.mail.replaceAll('\t', '&nbsp;&nbsp;&nbsp;&nbsp;');
      this.mail = this.mail.replaceAll('<img&nbsp;', '<img ');
      this.mail = this.mail.replaceAll('<strong&nbsp;', '<strong ');
      this.mail = this.mail.replaceAll('<span&nbsp;', '<span ');
      this.mail = this.mail.replaceAll('color:&nbsp;', 'color: ');

      this.mail = this.mail.replaceAll('<p&nbsp;class=', '<p class=');
      this.mail = this.mail.replaceAll('<p class="ql-indent-1">', '<p>&emsp;&emsp;');
      this.mail = this.mail.replaceAll('<p class="ql-indent-2">', '<p>&emsp;&emsp;&emsp;');
      this.mail = this.mail.replaceAll('<p class="ql-indent-3">', '<p>&emsp;&emsp;&emsp;&emsp;&emsp;');
      this.mail = this.mail.replaceAll('<p class="ql-indent-4">', '<p>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;');
      this.mail = this.mail.replaceAll('<p class="ql-indent-5">', '<p>&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;');


      this.mail = this.mail.replaceAll('<a&nbsp;href=', '<a href=');
      this.mail = this.mail.replaceAll('&nbsp;rel=', ' rel=');
      this.mail = this.mail.replaceAll('&nbsp;target=', ' target=');
      this.mail = this.replaceColor(this.mail);

      this.mail = this.mail.replaceAll('<pre&nbsp;', '<pre ');
      this.mail = this.mail.replaceAll('&nbsp;spellcheck=', ' style="background-color: #23241f;color: #f8f8f2;overflow: visible;" spellcheck=');
      this.mail = this.mail.replaceAll('<p&nbsp;class=', '<p class=');
      this.mail = this.mail.replaceAll('class="ql-align-right"', 'style="text-align: right;"');
      this.mail = this.mail.replaceAll('class="ql-align-center"', 'style="text-align: center;"');
      this.mail = this.mail.replaceAll('class="ql-align-justify"', 'style="text-align: justify;"');
      this.mail = this.mail.replaceAll('class="ql-size-small"', 'style="font-size: 0.75em;"');
      this.mail = this.mail.replaceAll('class="ql-size-large"', 'style="font-size: 1.5em;"');
      this.mail = this.mail.replaceAll('class="ql-size-huge"', 'style="font-size: 2.5em;"');
      this.mail = this.mail.replaceAll('noopener&nbsp;noreferrer', 'noopener noreferrer');

      this.mail = this.mail.replaceAll(
        'style="cursor:&nbsp;nwse-resize;"',
        ' style="cursor: nwse-resize;"'
      );
      this.mail = this.mail.replaceAll('&nbsp;width=', ' width=');
      let message = {
        subject: this.form[4].value,
        body: {
          contentType: 'html',
          content: this.mail,
        },
        toRecipients: [],
        ccRecipients: [],
        bccRecipients: [],
        attachments: [],
        attachments_temp: [],
      };
      let to = [];
      if (this.form[1].tags.length > 0) {
        this.form[1].tags.forEach((element) => {
          let obj = {
            emailAddress: {
              address: element.text,
            },
          };
          to.push(obj);
        });
        message['toRecipients'] = to;
      }
      let cc = [];
      if (this.form[2].tags.length > 0) {
        this.form[2].tags.forEach((element) => {
          let obj = {
            emailAddress: {
              address: element.text,
            },
          };
          cc.push(obj);
        });
        message['ccRecipients'] = cc;
      }
      let bcc = [];
      if (this.form[3].tags.length > 0) {
        this.form[3].tags.forEach((element) => {
          let obj = {
            emailAddress: {
              address: element.text,
            },
          };
          bcc.push(obj);
        });
        message['bccRecipients'] = bcc;
      }
      let mail_detail = {
        job_id: this.mailId,
        tracking_id: this.form[5].value,
        mail_type: this.sendType == 'New Mail' ? 'New Mail' : 'Outgoing',
        send_type: this.sendType,
        status: this.sendType == 'New Mail' ? 'Close' : 'Open',
      };
      let mail_body = {
        message: message,
        saveToSentItems: true,
      };
      let payload = new FormData();
      payload.append('mail_detail', JSON.stringify(mail_detail));
      payload.append('mail_body', JSON.stringify(mail_body));
      let fileInternal = [];
      let fileInbound = [];
      this.attachments.forEach((element) => {
        if (element.from == 'internal') {
          fileInternal.push(element);
        } else if (element.from == 'external') {
          payload.append('file_external', element.file);
        } else if (element.from == 'inbound' && this.sendType != 'forward') {
          // payload.append('file_external', element.file);
          fileInbound.push(element);
        }
      });
      payload.append('mail_id', this.mailAttID);
      payload.append('file_internal', JSON.stringify(fileInternal));
      payload.append('file_inbound', JSON.stringify(fileInbound));
      switch (this.sendType) {
        case 'New Mail':
          var url = `/api/mail/${this.mailId}/send/newmail`;
          break;
        case 'reply':
          var url = `/api/mail/${this.mailId}/send/reply`;
          break;
        case 'replyAll':
          var url = `/api/mail/${this.mailId}/send/replyAll`;
          break;
        case 'forward':
          var url = `/api/mail/${this.mailId}/send/forward`;
          break;
      }
      requestService.PostCcpFetch('ccp', url, payload, 'form-data').then(() => {
        if (this.sendType == 'New Mail') {
          this.onCloseJob();
        } else {
          // this.setUpForm('In Process', this.tempMailDetail);
          this.icons[5].hidden = true;
          this.form[1].disable = true;
          this.form[2].disable = true;
          this.form[3].disable = true;
          this.form[4].disable = true;
          this.sendType = '';
          this.editorDisable = true;
          this.$swal.fire({
            icon: 'success',
            title: 'Send Success',
            showConfirmButton: false,
            timer: 1500,
          });
        }
      })
        .catch((err) => {
          this.$swal.fire({
            text: `${err}`,
            icon: 'error',
            showCancelButton: false,
            confirmButtonColor: '#2971FF',
            confirmButtonText: 'ยืนยัน',
          }).then((result) => {
            if (result.isConfirmed) {
              this.refreshToken()
            }
          });
          // this.$swal.fire({
          //   icon: 'error',
          //   title: 'Try Again',
          //   text: err,
          // });
        });
    },
    getTimeMachine() {
      let timeMachine = localStorage.getItem(this.mailId);
      localStorage.removeItem(this.mailId);
      if (timeMachine != null) {
        this.$swal
          .fire({
            title: 'คุณต้องการคืนค่าข้อมูลหรือไม่',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2971FF',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
            camcelButtonText: 'Cancel',
          })
          .then((result) => {
            if (result.isConfirmed) {
              timeMachine = JSON.parse(timeMachine);
              if (timeMachine.to.length > 0) {
                let to = [];
                timeMachine.to.forEach((element) => {
                  to.push({ text: element, tiClasses: ['ti-valid'] });
                });
                this.form[1].tags = to;
              }
              if (timeMachine.cc.length > 0) {
                let cc = [];
                timeMachine.cc.forEach((element) => {
                  cc.push({ text: element, tiClasses: ['ti-valid'] });
                });
                this.form[2].tags = cc;
              }
              if (timeMachine.bcc.length > 0) {
                let bcc = [];
                timeMachine.bcc.forEach((element) => {
                  bcc.push({ text: element, tiClasses: ['ti-valid'] });
                });
                this.form[3].tags = bcc;
              }
              if (timeMachine.message != '') {
                this.mail = timeMachine.message;
              }
              if (timeMachine.subject != '') {
                this.form[4].value = timeMachine.subject;
              }
            }
          });
      } else {
        return;
      }
    },
    setUpForm(type, detail) {
      detail.bcc_recipients = this.removeDup(detail.bcc_recipients);
      detail.to_recipients = this.removeDup(detail.to_recipients);
      detail.cc_recipients = this.removeDup(detail.cc_recipients);

      let to = [];
      let cc = [];
      let bcc = [];
      let self = this;
      self.tempMailDetail = detail;
      self.form[0].value = self.mailItone;
      self.form[1].tags = [];
      self.form[2].tags = [];
      self.form[3].tags = [];
      switch (type) {
        case 'draft mail':
        case 'New Mail':
          self.form[5].value = detail.tracking_id;
          self.form[4].value = detail.subject;
          self.sendType = 'New Mail';
          self.mail = '';
          if (
            detail.to_recipients != undefined &&
            detail.to_recipients.length > 0
          ) {
            self.form[1].hidden = true;
            detail.to_recipients.forEach((element) => {
              to.push({ text: element, tiClasses: ['ti-valid'] });
            });
            self.form[1].tags = to;
          }
          if (
            detail.cc_recipients != undefined &&
            detail.cc_recipients.length > 0
          ) {
            self.form[2].hidden = true;
            detail.cc_recipients.forEach((element) => {
              cc.push({ text: element, tiClasses: ['ti-valid'] });
            });
            self.form[2].tags = cc;
          }
          if (
            detail.bcc_recipients != undefined &&
            detail.bcc_recipients.length > 0
          ) {
            self.form[3].hidden = true;
            detail.bcc_recipients.forEach((element) => {
              bcc.push({ text: element, tiClasses: ['ti-valid'] });
            });
            self.form[3].tags = bcc;
          } else {
            self.form[3].hidden = true;
            self.form[3].tags.push({
              text: this.user.email,
              tiClasses: ['ti-valid'],
            });
          }
          self.icons[0].hidden = true;
          self.icons[1].hidden = true;
          self.icons[2].hidden = true;
          self.icons[3].hidden = false;
          self.icons[4].hidden = false;
          self.icons[5].hidden = true;
          self.isInbound = true;
          self.form[1].disable = false;
          self.form[2].disable = false;
          self.form[3].disable = false;
          self.form[4].disable = false;
          self.editorDisable = false;
          self.getTimeMachine();
          break;
        case 'In Process':
        case 'Open':
        case 'Pending':
          if (detail.type == 'New Mail') {
            self.setUpForm('New Mail', detail);
            return;
          }
          self.attachments = [];
          self.temp_attachments.forEach((element) => {
            self.attachments.push(element);
          });
          self.form[5].value = detail.tracking_id;
          self.form[4].value = detail.subject;
          to.push({ text: detail.from, tiClasses: ['ti-valid'] });
          if (
            detail.to_recipients != undefined &&
            detail.to_recipients.length >= 1
          ) {
            detail.to_recipients.forEach((element) => {
              var exists = to.some(item => item.text === element);
              if (!exists) {
                to.push({ text: element, tiClasses: ['ti-valid'] });
              }
            });
          }
          self.form[1].tags = to;
          if (
            detail.cc_recipients != undefined &&
            detail.cc_recipients.length > 0
          ) {
            self.form[2].hidden = true;
            detail.cc_recipients.forEach((element) => {
              cc.push({ text: element, tiClasses: ['ti-valid'] });
            });
            self.form[2].tags = cc;
          }
          if (
            detail.bcc_recipients != undefined &&
            detail.bcc_recipients.length > 0
          ) {
            self.form[3].hidden = true;
            detail.bcc_recipients.forEach((element) => {
              bcc.push({ text: element, tiClasses: ['ti-valid'] });
            });
            self.form[3].tags = bcc;
          }
          self.icons[0].hidden = false;
          self.icons[1].hidden = false;
          self.icons[2].hidden = false;
          self.icons[3].hidden = false;
          self.icons[4].hidden = false;
          self.icons[5].hidden = false;
          self.mail = '';
          self.isInbound = true;
          self.getTimeMachine();
          break;
      }
    },
    removeDup(arr) {
      let result = []
      arr.forEach((item, index) => { if (result.indexOf(item) === -1) result.push(item) });
      return result;
    },
    newMail() {
      let url = '/api/desktop/new/job';
      let bcc = [];
      bcc.push(this.user.email);
      const object = {
        form: this.mailItone,
        bcc: bcc,
      };
      requestService.PostCcpFetch('ccp', url, object).then((response) => {
        if (response.status == 200) {
          response.text().then((text) => {
            let self = this;
            const data = text && JSON.parse(text);
            if (data != null) {
              self.mailId = data.id;
              let detail = {
                to_recipients: [],
                cc_recipients: [],
                bcc_recipients: [],
                tracking_id: data.tracking_id,
                subject: '',
              };
              self.setUpForm('draft mail', detail);
              self.editorDisable = false;
              self.$root.$data.WorkerIO.port.postMessage([
                'changeStatus',
                'acd',
              ]);
            }
          });
        }
      }).catch((err) => {
        this.$swal.fire({
          text: `${err}`,
          icon: 'error',
          showCancelButton: false,
          confirmButtonColor: '#2971FF',
          confirmButtonText: 'ยืนยัน',
        }).then((result) => {
          if (result.isConfirmed) {
            this.refreshToken()
          }
        });
      });
    },
    checkEmail(obj) {
      if (obj.tag.text.match(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/)) obj.addTag();
      else this.$notify({ text: 'Input is not Email', type: 'warn' });
    },
    replaceColor(text) {
      var pos = 0;
      while (true) {
        let result = text.indexOf("rgb(", pos);
        //console.log("result",result);
        if (result == -1) {
          break;
        }

        let result1 = text.indexOf(");", result);
        //console.log("result1",result1);

        const raw = text.substring(result, result1);
        //console.log("raw",raw,typeof raw);
        //const rawReplace = raw.toString().replaceAll("&nbsp;", "");
        const rawReplace = raw.split('&nbsp;').join('');
        //console.log("rawReplace",rawReplace);
        text = text.replace(raw, rawReplace);
        //console.log("text",text);
        let result2 = text.indexOf(rawReplace, pos);
        //console.log("result2",result2);
        //console.log("new location",result2+1);
        pos = result2 + 1;
      }
      //console.log("x",x);
      return text;
    },
  },
};
</script>
<style>
.ribbon-custom-right {
  padding: 0 20px;
  height: 30px;
  line-height: 30px;
  clear: left;
  position: absolute;
  top: 12px;
  right: 0px;
  color: #fff;
  z-index: 2;
}

.ribbon-custom-left {
  padding: 0 20px;
  height: 30px;
  line-height: 30px;
  clear: left;
  position: absolute;
  top: 12px;
  left: 0px;
  color: #fff;
  z-index: 2;
}

.ti-input {
  padding: 0.4rem !important;
}

.bg-blue {
  background-color: #e4edff !important;
}

.bg-blue:hover {
  background-color: #d5e3ff !important;
}

.icon {
  justify-items: center;
  cursor: pointer;
  display: grid;
  width: max-content;
  padding: 0 5px;
}

.btn-gray {
  padding: 0.5rem;
  border-radius: 1rem;
  transition: all 0.3s;
}

.btn-gray:hover {
  background-color: #e0ebff;
}
</style>
